import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftCircle } from 'lucide-react';
import { useSocket } from '../context/SocketContext';
import DisclaimerDialog, { APP_VERSION } from '../components/DisclaimerDialog';

const SettingsPage: React.FC = () => {
  const navigate = useNavigate();
  const { setPlayerId } = useSocket();
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const playerId = localStorage.getItem('playerId') || '';

  const handleLogout = () => {
    setPlayerId(null);
    navigate('/login');
  };

  return (
    <div className="page bg-primary-dark pt-4 px-4 pb-4">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <button
          className="bg-primary text-white h-[44px] pl-2 pr-4 rounded-full flex items-center gap-1 border-none cursor-pointer active:opacity-80"
          onClick={() => navigate(-1)}
        >
          <ArrowLeftCircle size={32} className="text-white" />
          <span className="font-serif text-sm font-bold">Back</span>
        </button>
        <h1 className="text-white text-3xl font-serif font-bold m-0">Settings</h1>
      </div>

      {/* White Card */}
      <div className="bg-white rounded-[48px] py-6 px-5">
        {/* Player INFO Section */}
        <h3 className="font-serif text-lg font-bold text-black mb-3">Player INFO</h3>

        {/* Player ID Row */}
        <div className="flex justify-between items-center py-2">
          <span className="font-serif text-base font-bold text-black">Player ID</span>
          <span className="font-serif text-base font-bold text-black">{playerId}</span>
        </div>

        {/* APP Version Row */}
        <div className="flex justify-between items-center py-2">
          <span className="font-serif text-base font-bold text-black">APP Version</span>
          <span className="font-serif text-base font-bold text-black">{APP_VERSION}</span>
        </div>

        {/* Terms of Use & Disclaimer Row */}
        <div
          className="flex justify-between items-center py-2 cursor-pointer active:opacity-70"
          onClick={() => setShowDisclaimer(true)}
        >
          <span className="font-serif text-base font-bold text-black">Terms of Use & Disclaimer</span>
          <span className="text-black text-xl">→</span>
        </div>
      </div>

      {/* Fixed Bottom Logout Button */}
      <div className="fixed bottom-0 left-0 right-0 p-4 pb-[calc(16px+env(safe-area-inset-bottom,0px))]">
        <button
          className="w-full bg-[#FF0B0F] text-white py-5 rounded-full font-serif text-xl font-bold border-none cursor-pointer active:opacity-80"
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>

      {/* Disclaimer Dialog */}
      <DisclaimerDialog
        isOpen={showDisclaimer}
        onClose={() => setShowDisclaimer(false)}
        showVersion={true}
      />
    </div>
  );
};

export default SettingsPage;
